import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { EditPayable } from '../presentation/components/pageComponents/home/EditPayable/EditPayable';
import { NewRelease } from '../presentation/components/pageComponents/home/NewRelease/NewRelease';
import { Categories } from '../presentation/pages/admin/categories/Categories';
import { ClientAdmin } from '../presentation/pages/admin/clients/ClientAdmin';
import { FormClients } from '../presentation/pages/admin/clients/FormClients';
import { ConstructionAdmin } from '../presentation/pages/admin/constructions/ConstructionAdmin';
import { ConstructionsDetails } from '../presentation/pages/admin/constructions/ConstructionsDetails/ConstructionsDetails';
import { ConstructionsTour } from '../presentation/pages/admin/constructions/ConstructionsTour';
import { EditBudgetV2 } from '../presentation/pages/admin/constructions/ConstructionsDetails/budgets/NewBudget/EditBudgetV2/EditBudgetV2';
import { NewBudget } from '../presentation/pages/admin/constructions/ConstructionsDetails/budgets/NewBudget/NewBudget';
import { NewTimeline } from '../presentation/pages/admin/constructions/ConstructionsDetails/timeline/NewTimeline/NewTimeline';
import { FormConstructions } from '../presentation/pages/admin/constructions/FormConstructions';
import HomeAdmin from '../presentation/pages/admin/home/HomeAdmin';
import { SettingsAdmin } from '../presentation/pages/admin/settings/SettingsAdmin';
import { FormSuppliers } from '../presentation/pages/admin/suppliers/FormSuppliers';
import { SupplierAdmin } from '../presentation/pages/admin/suppliers/SupplierAdmin';
import { SupportAdmin } from '../presentation/pages/admin/support/SupportAdmin';
import { FaqAdmin } from '../presentation/pages/admin/faq/FaqAdmin';
import { FormTickets } from '../presentation/pages/admin/support/FormTickets';
import { SupportTicket } from '../presentation/pages/admin/support/SupportTicket';
import { RedirectToPayables } from './RedirectToPayables';

export default function AdminRoutes() {
  return (
    <Routes>
      {/* Mesma ordem e caminho das rotas antigas */}
      <Route path="/admin" element={<HomeAdmin />} />
      <Route path="/new-release" element={<NewRelease />} />
      <Route path="/new-release/:id" element={<EditPayable />} />
      <Route path="/new-release/duplicate/:id" element={<EditPayable />} />
      <Route path="/suppliers" element={<SupplierAdmin />} />
      <Route path="/new-supplier" element={<FormSuppliers />} />
      <Route path="/new-supplier/:id" element={<FormSuppliers />} />
      <Route path="/clients" element={<ClientAdmin />} />
      <Route path="/new-client" element={<FormClients />} />
      <Route path="/new-client/:id" element={<FormClients />} />
      <Route path="/constructions" element={<ConstructionAdmin />} />
      <Route path="/constructions/tour/:page" element={<ConstructionsTour />} />
      <Route
        path="/constructions/:id/:page"
        element={<ConstructionsDetails />}
      />
      <Route path="/constructions/:id" element={<RedirectToPayables />} />
      <Route path="/new-timeline/:id" element={<NewTimeline />} />
      <Route path="/new-budget" element={<NewBudget />} />
      <Route path="/new-budget/:id" element={<NewBudget />} />
      <Route path="/budget/:id" element={<EditBudgetV2 />} />
      <Route path="/new-construction" element={<FormConstructions />} />
      <Route path="/new-construction/:id" element={<FormConstructions />} />
      <Route path="/support" element={<SupportAdmin />} />
      <Route path="/faq" element={<FaqAdmin />} />
      <Route path="/new-ticket" element={<FormTickets />} />
      <Route path="/ticket/:id" element={<SupportTicket />} />
      <Route path="/categories" element={<Categories />} />
      <Route path="/settings" element={<SettingsAdmin />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}
